import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.tsx";

interface PublicHeaderProps {
  title: string;
}

/**
 * Hlavička veřejné stránky. Nepřihlášenému nabídne přihlášení,
 * přihlášenému zkratku zpět do administrace.
 */
const PublicHeader: React.FC<PublicHeaderProps> = ({ title }) => {
  const { currentUser } = useAuth();

  return (
    <header className="sticky top-0 z-10 bg-slate-900/95 backdrop-blur text-white border-b border-white/10">
      <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <span className="text-2xl leading-none" aria-hidden="true">
            ♞
          </span>
          <div className="min-w-0">
            {/* Jediný h1 stránky – v hero sekci už název neopakujeme */}
            <h1 className="font-semibold truncate">{title}</h1>
            <div className="text-xs text-slate-400">Výsledky a pořadí</div>
          </div>
        </div>

        <div className="flex items-center gap-3 shrink-0">
          {currentUser ? (
            <>
              <span className="hidden sm:inline text-sm text-slate-300 truncate max-w-[16rem]">
                {currentUser.email}
              </span>
              <Link
                to="/admin"
                className="px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm font-medium transition-colors"
              >
                Administrace
              </Link>
            </>
          ) : (
            <Link
              to="/login"
              className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-500 text-sm font-medium transition-colors"
            >
              Přihlásit se
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
